"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SCHEMA = 'iglu:com.angi.entities/user_type_attributes/jsonschema/1-0-2';
const allowedUserTypes = ['PRO', 'HOMEOWNER'];
/**
 * Generates the user_type_attributes context
 *
 * @param userType - user type (either Pro or Homeowner)
 */
const userTypeAttributesContext = (userType) => {
    const capitalizedUserType = userType.toUpperCase();
    if (!allowedUserTypes.includes(capitalizedUserType)) {
        console.warn(`Invalid user type "${userType}". Please use one of the following: ${allowedUserTypes.join(', ')}`);
        return;
    }
    return {
        schema: SCHEMA,
        data: { user_type: capitalizedUserType },
    };
};
exports.default = userTypeAttributesContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlclR5cGVBdHRyaWJ1dGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2RhdGFTdHJ1Y3R1cmVzL2VudGl0aWVzL3VzZXJUeXBlQXR0cmlidXRlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBLE1BQU0sTUFBTSxHQUFHLDhEQUE4RCxDQUFDO0FBQzlFLE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxLQUFLLEVBQUUsV0FBVyxDQUFDLENBQUM7QUFFOUM7Ozs7R0FJRztBQUNILE1BQU0seUJBQXlCLEdBQUcsQ0FBQyxRQUFnQixFQUFrQyxFQUFFO0lBQ25GLE1BQU0sbUJBQW1CLEdBQUcsUUFBUSxDQUFDLFdBQVcsRUFBRSxDQUFDO0lBRW5ELElBQUksQ0FBQyxnQkFBZ0IsQ0FBQyxRQUFRLENBQUMsbUJBQW1CLENBQUMsRUFBRTtRQUNqRCxPQUFPLENBQUMsSUFBSSxDQUNSLHNCQUFzQixRQUFRLHVDQUF1QyxnQkFBZ0IsQ0FBQyxJQUFJLENBQ3RGLElBQUksQ0FDUCxFQUFFLENBQ04sQ0FBQztRQUNGLE9BQU87S0FDVjtJQUVELE9BQU87UUFDSCxNQUFNLEVBQUUsTUFBTTtRQUNkLElBQUksRUFBRSxFQUFFLFNBQVMsRUFBRSxtQkFBbUIsRUFBRTtLQUMzQyxDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUseUJBQXlCLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/dataStructures/entities/userTypeAttributes.ts